'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Spinner = require('./Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ActionSpinner = function ActionSpinner(_ref) {
    var _ref$hideMessage = _ref.hideMessage,
        hideMessage = _ref$hideMessage === undefined ? true : _ref$hideMessage,
        props = _objectWithoutProperties(_ref, ['hideMessage']);

    return _react2.default.createElement(
        _Spinner2.default,
        _extends({}, props, {
            className: 'd-inline-block ' + (props.className ? props.className : ''),
            ariaLive: 'polite',
            size: props.size || 'lg',
            color: props.color || 'primary',
            center: false
        }),
        _react2.default.createElement(
            'span',
            { className: '' + (hideMessage ? 'sr-only' : null) },
            props.message
        )
    );
};

ActionSpinner.propTypes = _extends({}, _Spinner.spinnerProps, {
    message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
    hideMessage: _propTypes2.default.bool
});

exports.default = ActionSpinner;